module.exports = __webpack_public_path__ + "img/logo-ans.147d587d.png";